<template>
  <div id="role">
    <img
      id="role-title"
      :src="require('../assets/images/role-title-' + $i18n.locale + '.png')"
    />
    <div id="roles">
      <img
        class="roles-head"
        v-for="(item, index) in rolesHead"
        :key="'head-' + index"
        :id="item"
        :src="item == activeRole
          ? require('../assets/images/' + item + '-active.png')
          : require('../assets/images/' + item + '.png')
          "
      />
      <div
        class="roles-box"
        v-for="(item, index) in rolesHead"
        :key="'box-' + index"
        :id="item + '-box'"
        @click.stop="changeRole(item)"
      ></div>
    </div>
    <div id="role-intro">
      <p id="intro-title-big">{{ $t("role." + activeRole + ".name") }}</p>
      <p id="intro-title-normal">{{ $t("role." + activeRole + ".name") }}</p>
      <img
        id="intro-title-de1"
        src="../assets/images/title-de1.png"
      />
      <p id="intro-content">
        {{ $t("role." + activeRole + ".intro") }}
      </p>
    </div>
    <!-- <img
      id="role-image"
      :src="require('../assets/images/' + activeRole + '-back.png')"
    /> -->
    <img
      id="role-image-back"
      :src="getNewRoleImg('back', activeRole)"
    />
    <img
      id="role-image-bottom"
      :src="getNewRoleImg('bottom', activeRole)"
    />
    <img
      id="role-video-play"
      src="../assets/images/role-video.png"
      @click.self="toggleVideo(true)"
    />
    <div
      id="role-video"
      v-if="videoShow"
      @click.self="toggleVideo(false)"
    >
      <video
        id="video-main"
        :src="getVideoURL"
        autoplay
        loop
        controls
      >
        {{ $t("role.playerWarning") }}
      </video>
      <img
        id="close"
        src="../assets/images/close.png"
        @click.stop="toggleVideo(false)"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeRole: "nt",
      rolesHead: ["rg", "a", "hk", "hb", "nol", "kk", "ma", "es", "tk", "jn", "rc", "hzm", "bl", "nt"],
      videoShow: false,
    }
  },
  methods: {
    changeRole(role) {
      this.activeRole = role
    },
    toggleVideo(bol) {
      this.videoShow = bol
      let body = document.getElementsByTagName("body")[0]
      if (bol) {
        body.style.overflow = "hidden"
      } else {
        body.style.overflow = null
      }
    }
  },
  computed: {
    getVideoURL() {
      return 'https://bbeex.91act.com/videos/' + this.activeRole + '.mp4'
    },
    getNewRoleImg() {
      // 1. 预先定义资源上下文：指定目录、是否递归子目录、匹配图片的正则
      const roleImgContext = require.context(
        '../assets/images/202510/role', // 图片根目录（相对当前文件的路径）
        true, // 是否搜索子目录（这里需要，因为图片在 ${role} 子目录下）
        /\/([^/]+)\/\1-([^/]+)\.png$/ // 匹配 `${role}/${role}-${key}.png` 格式的正则
      )

      // 2. 返回接收参数的函数，通过上下文获取图片
      return (key, role) => {
        // 拼接相对上下文的路径（注意开头要加 ./）
        const imgPath = `./${role}/${role}-${key}.png`
        // 通过上下文加载图片
        return roleImgContext(imgPath)
      }
    }
  }
}
</script>

<style scoped>
#role {
  width: 750px;
  height: 1795px;
  position: relative;
  background-image: url("../assets/images/role-back.png");
  background-size: 100%;
  background-repeat: no-repeat;
  overflow: hidden;
}

#role-title {
  width: 750px;
  height: 80px;
  position: absolute;
  left: 0;
  top: 59px;
}

#roles {
  width: 70%;
  height: 639px;
  position: absolute;
  top: 35px;
  left: 0;
  background-image: url("../assets/images/role-head-back-1.png");
  background-size: 115%;
  background-repeat: no-repeat;
  background-position: 200%;
}

.roles-head {
  width: 180px;
  height: 160px;
  position: absolute;
  z-index: 9;
}

.roles-box {
  width: 100px;
  height: 100px;
  border-radius: 50px;
  position: absolute;
  z-index: 99;
}

#rg {
  top: 155px;
  left: 100px;
}

#rg-box {
  top: 165px;
  left: 142px;
}

#a {
  top: 170px;
  right: 155px;
}

#a-box {
  top: 220px;
  left: 232px;
}

#hk {
  top: 155px;
  right: 65px;
}

#hk-box {
  top: 168px;
  right: 105px;
}

#hb {
  top: 170px;
  right: -25px;
}

#hb-box {
  top: 220px;
  right: 15px;
}

#tk {
  top: 155px;
  right: -115px;
}

#tk-box {
  top: 165px;
  right: -75px;
}

#nol {
  top: 325px;
  left: 100px;
}

#nol-box {
  top: 375px;
  left: 140px;
}

#icey {
  top: 310px;
  left: 10px
}

#icey-box {
  top: 325px;
  left: 50px;
}

#kk {
  top: 310px;
  left: 190px;
}

#kk-box {
  top: 325px;
  left: 230px;
}

#es {
  top: 325px;
  right: 65px;
}

#es-box {
  top: 375px;
  right: 105px;
}

#ma {
  top: 310px;
  right: -25px;
}

#ma-box {
  top: 325px;
  right: 15px;
}

#jn {
  bottom: 13px;
  right: 62px;
}

#jn-box {
  bottom: 60px;
  right: 100px;
}

#rc {
  bottom: 0;
  right: 152px;
}

#rc-box {
  bottom: 10px;
  right: 195px;
}

#hzm {
  bottom: 13px;
  left: 100px;
}

#hzm-box {
  bottom: 60px;
  left: 140px;
}

#bl {
  top: 310px;
  left: 10px
}

#bl-box {
  top: 325px;
  left: 50px;
}

#nt {
  top: 170px;
  left: 10px;
}

#nt-box {
  top: 210px;
  left: 43px;
}

#role-intro {
  width: 405px;
  position: absolute;
  left: 10px;
  top: 650px;
  z-index: 9;
  color: #fff;
}

#intro-title-big {
  font-size: 60px;
  font-weight: 800;
  color: transparent;
  -webkit-text-stroke: 3px #2a107d;

  margin: 10px 0 0 0;
  padding: 0;
  box-sizing: border-box;
  line-height: 65px;
  padding-top: 5px;
  text-wrap: nowrap;

  font-family: "MiSans-Bold";
}

#intro-title-normal {
  position: absolute;
  top: 40px;
  left: 60px;
  font-size: 45px;
  color: #fff;

  margin: 0;
  padding: 0;
  box-sizing: border-box;
  line-height: 52px;
  padding-top: 5px;

  font-family: "MiSans-Bold";
}

#intro-title-de2 {
  width: 50px;
  height: 27px;
  position: absolute;
  top: 40px;
  right: 35px;
}

#intro-title-de1 {
  width: 356px;
  height: 2px;
  position: absolute;
  top: 120px;
  right: 95px;
}

#intro-content {
  width: 275px;
  margin-top: 50px;
  margin-left: 30px;

  font-family: "MiSans-Medium";
}

#role-image {
  width: 750px;
  height: 1096px;
  position: absolute;
  right: 0;
  top: 320px;
}

#role-image-back {
  width: 750px;
  height: 896px;
  position: absolute;
  right: 0;
  top: 620px;
  left: 80px;
  object-fit: cover;
  transform: scale(0.8);
}

#role-image-bottom {
  width: 750px;
  height: 422px;
  position: absolute;
  bottom: 230px;
}

#role-video-play {
  width: 534px;
  height: 320px;
  position: absolute;
  left: 103px;
  bottom: 10px;
  z-index: 99;
}

#role-video {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}

#video-main {
  width: 100%;
  height: auto;
  position: absolute;
  top: 350px;
  left: 0;
  z-index: 9999;
}

#close {
  width: 39px;
  height: 39px;
  position: absolute;
  top: 300px;
  right: 50px;
  z-index: 9999;
}
</style>
